import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const refreshUsageForOrg = (orgId, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'REFRESH_ORGANIZATION_USAGE' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.put(`/ads/orgs/${orgId}/usage`, null, {
            params: {
              'request-id': reqId,
            },
            headers: {
              Authorization: `Bearer ${token}`,
              // 'x-api-version': 'v2',
            },
          });
          if (response.status === 200) {
            await dispatch({
              type: 'REFRESH_ORGANIZATION_USAGE_DONE',
              payload: {
                orgId: response?.data,
              },
            });
            if (typeof callback === 'function') {
              callback(orgId);
            }
          } else {
            dispatch({
              type: 'REFRESH_ORGANIZATION_USAGE_FAILED',
              payload: `Failed to refresh usage`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'REFRESH_ORGANIZATION_USAGE_FAILED',
            payload: `Failed to refresh usage`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'REFRESH_ORGANIZATION_USAGE_FAILED',
        payload: `Failed to refresh usage`,
      });
    }
  };
};

export default refreshUsageForOrg;
